export default function Overlay({open = false, onClose}) {
    return (
        <div
            className={`fixed w-screen h-screen top-0 left-0 z-10 ${open ? "" : "hidden"}`}
            onClick={() => onClose(false)}
        />

    )
}
